import React from "react";
import '../../Common.css';
import './MyProfilePage.css';
// api and other functions
import { useContext,useEffect,useState } from "react";
import { AuthContext } from "../../services/AuthContext";
import { PersonalProfileAPI,UpdateProfileAPI,DeleteAccountAPI } from "../../services/Api";
import { useNavigate } from "react-router-dom";
import { SendOTP,VerifyOTP,UserExists } from "../../services/Api";
import { LocationValidatorAR } from "../../services/Utilities";
// Components
import NavBar from "../../components/NavBar/NavBar";
import NavBarMainAR from "../../components/NavBarMain/NavBarMainAR";
import FooterAR from "../../components/Footer/FooterAR";
import InputTextField from "../../components/InputFields/InputTextField/InputTextField";
import PrimaryMutedButton from "../../components/Buttons/PrimaryMutedButton/PrimaryMutedButton";
import PrimarySolidButton from "../../components/Buttons/PrimarySolidButton/PrimarySolidButton";
import UserIconAndName from "../../components/UserIconAndName/UserIconAndName";
import ResetPasswordPopUpAR from "../../components/PopUps/ForgotPassword/ResetPasswordAR";
import DeleteAccountAR from "../../components/PopUps/DeleteAccountPopUP/DeleteAccountAR";
import ScuccessPopUp from "../../components/PopUps/AccountCreationSuccess/ScuccessPopUp";
import ErrorMessageAR from "../../components/ErrorMessage/ErrorMessageAR";
import ValidateMobilePopUpAR from "../../components/PopUps/ForgotPassword/ValidateMobilePopUpAR";


const MyProfilePageAR = () => {
    const { fetchWithAuth,logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [ischangePass,setIsChangePass] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    const [navKey, setNavKey] = useState(0);
    const [errorMessage,setErrorMessage] = useState("");
    const [locationErrorMessage,setLocationErrorMessage] = useState("");
    const [isDeleteAccount, setIsDeleteAccount] = useState(false);
    const [isDeleteSuccess,setIsDeleteSuccess] =  useState(false);
    const [showOtpPopUp,setShowOtpPopUp] = useState(false);
    const [isRequired,setIsRequired] = useState(false);
    const [profileData, setProfileData] = useState({
        firstName: '',
        lastName: '',
        mobile: '',
        email: '',
        country: '',
        street1: '',
        street2: '',
        buildingDetails: '',
        city: '',
        state: '',
        zipcode: ''
    });
    const [initialMobile, setInitialMobile] = useState(profileData.mobile);
    const [initialEmail,setInitialEmail] = useState(profileData.email);
    const [otpError, setOtpError] = useState("");

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const response = await fetchWithAuth(PersonalProfileAPI);
                if (response.error) {
                    console.error("Error fetching profile:", response.error);
                } else {
                    setProfileData({
                        firstName: response.data.data.user.first_name || '',
                        lastName: response.data.data.user.last_name || '',
                        mobile: response.data.data.user.mobile || '',
                        email: response.data.data.user.email || '',
                        country: response.data.data.country || '',
                        street1: response.data.data.street1 || '',
                        street2: response.data.data.street2 || '',
                        buildingDetails: response.data.data.building || '',
                        city: response.data.data.city || '',
                        state: response.data.data.state || '',
                        zipcode: response.data.data.zip || ''
                    });
                    setInitialMobile(response.data.data.user.mobile || '');
                    setInitialEmail(response.data.data.user.email || '');
                }
            } catch (error) {
                console.error("Unexpected error:", error);
            }
        };

        fetchProfileData();
    }, []);

    //  all the toggles
    const handleEditToggle = () => {
        setIsRequired(true)
        setIsEditable(!isEditable);
    };

    const handleChangePassToggle = () =>{
        setIsChangePass(!ischangePass);
    };

    const closeOtpPopUp = () =>{
        setShowOtpPopUp(false);
    }

    const handleOtpChange = (name, value) => {
        setProfileData(prevData => ({
            ...prevData,
            [name]: value // Update the OTP field dynamically
        }));
    };

    const handleSendOTP = async() =>{
            const body={
                "mobile":profileData.mobile
            }
            try{
                const response = await SendOTP({body})
                if (response.error){
                    console.log("error sending otp")
                    return false;
                }
                else{
                    if (response.data.resp_code === 1){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            }
            catch(error){
                console.log("error sending otp",error)
                return false;
            }
        }
    
        const handleVerifyOtp = async() =>{
    
            const body = {
                "mobile":profileData.mobile,
                "otp":profileData.otp
            }
            if(!profileData.mobile.trim().length>0){
                setOtpError("الرجاء إدخال Otp للمتابعة")
            }
    
            try{
                const response = await VerifyOTP({body})
                if (response.error){
                    console.log(response)
                    setOtpError("كلمة مرور OTP غير متطابقة. يرجى المحاولة مرة أخرى.")
                    return;
                }
                else{
                    if (response.data.resp_code === 1){
                        setOtpError("");
                        setShowOtpPopUp(false);
                        submitMyProfileData();
                    }
                    else{
                        setOtpError("كلمة مرور OTP غير متطابقة. يرجى المحاولة مرة أخرى.")
                        return;
                    }
                }
            }
            catch(error){
                console.log("error sending otp",error)
                return;
            }
        }
    
        const handleSave =  async() => {
            if(!profileData.firstName.length>0){
                window.scrollTo({ top: 0, behavior: "smooth" });
                setErrorMessage("أدخل اسمك الأول للمتابعة")
                return;
            }
            else if(!profileData.mobile.length>0){
                window.scrollTo({ top: 0, behavior: "smooth" });
                setErrorMessage("أدخل رقم هاتفك المحمول للمتابعة")
                return;
            }
            else if(!profileData.email.length>0){
                window.scrollTo({ top: 0, behavior: "smooth" });
                setErrorMessage("أدخل بريدك الإلكتروني للمتابعة")
                return;
            }
            if(profileData.email !== initialEmail){
                const body = {
                    "mobile":profileData.mobile,
                    "email":profileData.email
                }
                
                const response = await UserExists({body})
                if(response.data.email_exists){
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    setErrorMessage("البريد الإلكتروني موجود بالفعل. حاول استخدام بريد آخر.")
                    return;
                }
            }
            if (profileData.mobile !== initialMobile) {
                const body = {
                    "mobile":profileData.mobile,
                    "email":profileData.email
                }
                const response = await UserExists({body})
                if(response.data.mobile_exists){
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    setErrorMessage("الجوال موجود بالفعل.جرب هاتفًا آخر.")
                    return;
                }
                const result = handleSendOTP();
                if (result){
                    setErrorMessage("");
                    setShowOtpPopUp(true);
                    return;
                }else{
                    return;
                }
            }
             // location field validations
            setLocationErrorMessage("");
            const { country,state,street1,buildingDetails,zipcode,city } = profileData;
            const fields = {"country":country,"state":state,"street1":street1,"building":buildingDetails,"city":city,"zip":zipcode}
            const message = LocationValidatorAR({fields})
            const locationContainer = document.getElementById('location-container');
            if (message.length>0){
                locationContainer.scrollIntoView({ behavior: "smooth", block: "start" });
                setLocationErrorMessage(message);
                return
            }

            submitMyProfileData();
        };
    
        const submitMyProfileData = async() =>{
            setErrorMessage("")
            const body ={
                "user": {
                    "first_name":profileData.firstName ,
                    "last_name":profileData.lastName ,
                    "mobile": profileData.mobile,
                    "email":profileData.email 
                },
                "country": profileData.country,
                "state": profileData.state,
                "city": profileData.city,
                "street1": profileData.street1,
                "street2": profileData.street2,
                "building": profileData.buildingDetails,
                "zip": profileData.zipcode
            }
            try {
                const response = await fetchWithAuth(UpdateProfileAPI, {body})
    
                if (response.error) {
                    console.error("Error updating profile:", response.error);
                } else {
                    console.log("Profile updated successfully!");
                    setIsEditable(false); // Disable editing mode
                    setIsRequired(false);
                    setNavKey(prevKey => prevKey + 1);
                }
            } catch (error) {
                console.error("Unexpected error while saving profile:", error);
            }
        }

    // Reset password section
    const handleSendOtp = async () => {
        const body={
            "mobile":profileData.mobile
        }
        try {
            const response = await SendOTP({ body });
            if (response.error){
                setErrorMessage("error sending otp");
                return;
            }
            else{
                if (response.data.resp_code === 1){
                    setErrorMessage("");
                }
                else{
                    setErrorMessage("حدث خطأ أثناء إرسال كلمة المرور لمرة واحدة (OTP). يرجى المحاولة مرة أخرى.");
                    return;
                }
            }
            
        } catch (error) {
            setErrorMessage("حدث خطأ ما. يرجى المحاولة مرة أخرى.");
            return;
        }
    };
    const openResetPassForm  = () =>{
        handleSendOtp();
        handleChangePassToggle();
    }
    const handleChangePassFormClose = () =>{
        setIsChangePass(false);
    }
    const handleSuccesChangePass = () =>{
        navigate("/");
        logout();
    }
    const toggleDeleteAccountPopUp = () =>{
        setIsDeleteAccount(!isDeleteAccount);
    }

    const handleDeleteAccount = async() =>{
            const body ={}
            try {
                const response = await fetchWithAuth(DeleteAccountAPI, {body})
                if (response.error) {
                    console.error("Error Deleting profile:", response.error);
                } else {
                    setIsDeleteSuccess(true);
                    setTimeout(() => {
                        setIsDeleteSuccess(false);
                        logout();
    
                    }, 2000);
                }
            } catch (error) {
                console.error("Unexpected error while Deleting profile:", error);
            }
    
        }
    const closeDeletePopUp = () =>{
        setIsDeleteAccount(false);
    }
    return (
        <div className="body-container">
            <div>
                <NavBarMainAR key={navKey}/>
                <div className="my-profile-main-container">
                    <div className="my-profile-sub-container">
                        <span className="my-profile-heading my-profile-heading-ar">ملفي الشخصي</span>
                        <div className="profile-cards-containers profile-cards-containers-ar">
                            <div className="user-name-section">
                                <UserIconAndName 
                                    UserName={`${profileData.firstName} ${profileData.lastName}`}
                                    direction="reverse"
                                />
                            </div>
                            {errorMessage &&
                            <div className="error-message-wrap">
                                <ErrorMessageAR message={errorMessage}/>
                            </div>
                            }
                            <div className="input-fields-container input-fields-container-ar">
                                <div className="half-width-input">
                                    <InputTextField
                                        htmlFor={"firstname"}
                                        content={"الاسم الأول"}
                                        value={profileData.firstName}
                                        onChange={(e) => setProfileData({ ...profileData, firstName: e.target.value })}
                                        readOnly={!isEditable}
                                        dir="rtl"
                                        isArabic = {true}
                                        required={isRequired}
                                    />
                                    <InputTextField
                                        htmlFor={"lastname"}
                                        content={"اسم العائلة"}
                                        value={profileData.lastName}
                                        onChange={(e) => setProfileData({ ...profileData, lastName: e.target.value })}
                                        readOnly={!isEditable}
                                        dir="rtl"
                                        isArabic = {true}
                                    />
                                </div>
                                <InputTextField
                                    htmlFor={"mobile"}
                                    content={"متحرك"}
                                    type={"mobile"}
                                    value={profileData.mobile}
                                    onChange={(e) => setProfileData({ ...profileData, mobile: e.target.value })}
                                    readOnly={!isEditable}
                                    dir="rtl"
                                    isArabic = {true}
                                    required={isRequired}
                                />
                                <InputTextField
                                    htmlFor={"email"}
                                    content={"بريد إلكتروني"}
                                    type={"email"}
                                    value={profileData.email}
                                    onChange={(e) => setProfileData({ ...profileData, email: e.target.value })}
                                    readOnly={!isEditable}
                                    dir="rtl"
                                    isArabic = {true}
                                    required={isRequired}
                                />
                            </div>
                        </div>
                        <div className="profile-cards-containers profile-cards-containers-ar" id="location-container">
                            <div className="input-fields-container">
                                <div className="profile-card-title profile-card-title-ar">موقع</div>
                                {locationErrorMessage &&
                                    <div className="error-message-wrap justify-end">
                                        <ErrorMessageAR message={locationErrorMessage}/>
                                    </div>
                                }
                                <InputTextField
                                    htmlFor={"country"}
                                    content={"دولة"}
                                    value={profileData.country}
                                    onChange={(e) => setProfileData({ ...profileData, country: e.target.value })}
                                    readOnly={!isEditable}
                                    dir="rtl"
                                    isArabic = {true}
                                    required={isRequired}
                                />
                                <div className="half-width-input">
                                    <InputTextField
                                        htmlFor={"street1"}
                                        content={"شارع 1"}
                                        value={profileData.street1}
                                        onChange={(e) => setProfileData({ ...profileData, street1: e.target.value })}
                                        readOnly={!isEditable}
                                        dir="rtl"
                                        isArabic = {true}
                                        required={isRequired}
                                    />
                                    <InputTextField
                                        htmlFor={"street2"}
                                        content={"شارع 2"}
                                        value={profileData.street2}
                                        onChange={(e) => setProfileData({ ...profileData, street2: e.target.value })}
                                        readOnly={!isEditable}
                                        dir="rtl"
                                        isArabic = {true}
                                    />
                                </div>
                                <InputTextField
                                    htmlFor={"builing-details"}
                                    content={"المنزل/رقم المبنى/الشقة"}
                                    value={profileData.buildingDetails}
                                    onChange={(e) => setProfileData({ ...profileData, buildingDetails: e.target.value })}
                                    readOnly={!isEditable}
                                    dir="rtl"
                                    isArabic = {true}
                                    required={isRequired}
                                />
                                <div className="half-width-input">
                                    <InputTextField
                                        htmlFor={"city"}
                                        content={"مدينة"}
                                        value={profileData.city}
                                        onChange={(e) => setProfileData({ ...profileData, city: e.target.value })}
                                        readOnly={!isEditable}
                                        dir="rtl"
                                        isArabic = {true}
                                        required={isRequired}
                                    />
                                    <InputTextField
                                        htmlFor={"state"}
                                        content={"الدولة / الإقليم / المنطقة"}
                                        value={profileData.state}
                                        onChange={(e) => setProfileData({ ...profileData, state: e.target.value })}
                                        readOnly={!isEditable}
                                        dir="rtl"
                                        isArabic = {true}
                                        required={isRequired}
                                    />
                                </div>
                                <InputTextField
                                    htmlFor={"zipcode"}
                                    content={"الرمز البريدي"}
                                    value={profileData.zipcode}
                                    onChange={(e) => setProfileData({ ...profileData, zipcode: e.target.value })}
                                    readOnly={!isEditable}
                                    dir="rtl"
                                    isArabic = {true}
                                    required={isRequired}
                                />
                            </div>
                        </div>
                        <div className="all-buttons-box arabic-flex">
                            <div className="save-profile-button-containers save-profile-button-containers-ar">
                                <PrimaryMutedButton
                                    label={"قم بإلغاء تنشيط حسابي"}
                                    onClick={toggleDeleteAccountPopUp}
                                    isdelete={true}
                                />
                            </div>
                            <div className="save-profile-button-containers save-profile-button-containers-ar">
                                <PrimaryMutedButton
                                    label={"تغيير كلمة المرور"}
                                    onClick={openResetPassForm}
                                />
                                <PrimarySolidButton
                                    label={isEditable ? "يحفظ" : "تحرير الملف الشخصي"}
                                    onClick={isEditable ? handleSave : handleEditToggle}
                                />
                            </div>
                        </div>
                    </div>
                    { ischangePass && 
                        <ResetPasswordPopUpAR 
                            onClose={handleChangePassFormClose}
                            onComplete={handleSuccesChangePass}
                            mobile={profileData.mobile}
                        />
                    }
                    { isDeleteAccount && <DeleteAccountAR onDelete={handleDeleteAccount} onClose={closeDeletePopUp} onCancel={toggleDeleteAccountPopUp}/>}
                    { isDeleteSuccess && <ScuccessPopUp message={"لقد تم إلغاء تنشيط حسابك بنجاح."}/> }
                    { showOtpPopUp && <ValidateMobilePopUpAR onSubmit={handleVerifyOtp} onClose={closeOtpPopUp}
                    onInputChange={handleOtpChange} otpError={otpError}/>}
                </div>
            </div>
            <FooterAR />
        </div>
    );
};

export default MyProfilePageAR;

